/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchProductService {
  productDetailChild: any = {isDetailPage: false, slug_name: '', pro_slug: ''};

  private messageSource = new BehaviorSubject(this.productDetailChild);
  currentMessage = this.messageSource.asObservable();
  changeMessage(message: any) {
    this.messageSource.next(message);
  }
}
